import { render, staticRenderFns } from "./WorkspaceSelector.vue?vue&type=template&id=62c94e78&scoped=true&"
import script from "./WorkspaceSelector.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSelector.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSelector.vue?vue&type=style&index=0&id=62c94e78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c94e78",
  null
  
)

export default component.exports